'use client'
import Script from 'next/script'
import { useSession } from 'next-auth/react'
import { useEffect } from 'react'
import { usePathname } from 'next/navigation'

const WIDGET_BASE = process.env.NEXT_PUBLIC_SALESABLY_WIDGET_URL || 'https://salesably-assistant-production.up.railway.app'
const HIDDEN_ROUTE_PREFIXES = ['/dashboard', '/prospects', '/companies', '/offers', '/settings', '/admin', '/reports']

function isHiddenRoute(pathname = '') {
  return HIDDEN_ROUTE_PREFIXES.some((prefix) => pathname === prefix || pathname.startsWith(`${prefix}/`))
}

export default function SalesablyWidget() {
  const { status } = useSession()
  const pathname = usePathname() || ''
  const isAuthenticated = status === 'authenticated'
  const shouldRenderWidget = !isAuthenticated && !isHiddenRoute(pathname)

  // Remove widget DOM elements when the widget should not be visible or when
  // the component unmounts. The external widget.js injects DOM outside React.
  useEffect(() => {
    const removeWidgetDom = () => {
      const widgetElements = document.querySelectorAll('[id*="salesably"], .salesably-widget, .salesably-widget-container')
      widgetElements.forEach(el => el.remove())
    }
    if (!shouldRenderWidget) removeWidgetDom()
    return removeWidgetDom
  }, [shouldRenderWidget, pathname])

  // Only show on public pages, never on signed-in app routes.
  if (!shouldRenderWidget) return null

  return (
    <>
      <Script id="salesably-widget-config" strategy="afterInteractive">
        {`
          window.SALESABLY_WIDGET_CONFIG = {
            studioId: "prep5",
            apiBase: "${WIDGET_BASE}",
            position: "bottom-right",
            theme: "light",
            company: {
              name: "Prep5"
            }
          };
        `}
      </Script>
      <Script
        src={`${WIDGET_BASE}/widget.js`}
        strategy="afterInteractive"
        onError={(e) => {
          console.warn('[Salesably] Widget failed to load', e)
        }}
      />
    </>
  )
}
